<template>
    <div>
        <Paper class="outer-paper">
            <div class="wrapper-div-vci">
                <div v-if="videoChatAction === 'invited'">
                    <div class="incoming-head">
                        <BaseIcon class="video-icon" name="video" />
                        Incoming video call ...
                    </div>
                </div>
                <div v-else>
                    <div class="incoming-head">
                        <BaseIcon class="video-icon" name="video" />
                        On-going call
                    </div>
                </div>
                <div v-if="videoChatAction === 'invited'">
                    <div class="avatar-wrapper">
                        <div
                            class="avatar-inner"
                            :style="{ backgroundColor: stringToColor(videoChatID) }"
                        >
                            <div
                                v-if="fromAvatar"
                                :style="{
                                    backgroundImage: 'url(\'' + fromAvatar + '/small.jpg\')',
                                }"
                                class="avatar"
                            ></div>
                            <div v-else style="display:flex;align-items:center;">
                                <BaseIcon class="icon" name="user" />
                            </div>
                        </div>
                        <strong>{{ fromName }}</strong>
                    </div>
                    <div v-if="!confirmDecline" class="button-wrapper">
                        <div class="deny-btn btn-inner">
                            <div class="btn-primary btn round-btn" @click="closeDialogConfirm">
                                <BaseIcon class="icon phone-icon-rotate" name="phone" />
                            </div>
                            <div class="btn-label">Decline</div>
                        </div>
                        <div class="accept-btn btn-inner">
                            <div class="btn-primary btn round-btn" @click="joinChat">
                                <BaseIcon class="icon" name="video" />
                            </div>
                            <div class="btn-label">Accept</div>
                        </div>
                    </div>
                    <div v-else class="button-wrapper">
                        <div class="deny-btn btn-inner btn-inner-confirm">
                            <div
                                class="btn-primary btn round-btn confirm-button"
                                @click="closeDialog"
                            >
                                <BaseIcon class="icon phone-icon-rotate" name="phone" />
                                <div class="btn-label confirm-text">Confirm Decline</div>
                            </div>
                            <BaseButton variant="text-primary" @click="backFromConfirm"
                                >Back</BaseButton
                            >
                        </div>
                    </div>
                </div>
                <div v-else>
                    <p class="m-2">
                        You have an active video call on-going, do you wish to re-join the meeting?
                    </p>
                    <div class="button-wrapper">
                        <div class="accept-btn btn-inner btn-inner-confirm">
                            <div class="btn-primary btn round-btn confirm-button" @click="joinChat">
                                <BaseIcon class="icon" name="video" />
                                <div class="btn-label confirm-text">Re-join</div>
                            </div>
                            <BaseButton variant="text-primary" @click="closeDialog"
                                >Close</BaseButton
                            >
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <div v-if="newInvites.length" class="new-invites">
                    <div v-for="(item, index) in newInvites" :key="index">
                        <div class="new-invite-wrapper">
                            <div class="avatar-wrapper">
                                <div
                                    class="avatar-inner"
                                    :style="{ backgroundColor: stringToColor(item.videoChatID) }"
                                >
                                    <div
                                        v-if="item.fromAvatar"
                                        :style="{
                                            backgroundImage:
                                                'url(\'' + item.fromAvatar + '/small.jpg\')',
                                        }"
                                        class="avatar"
                                    ></div>
                                    <div v-else style="display:flex;align-items:center;">
                                        <BaseIcon class="icon" name="user" />
                                    </div>
                                </div>
                            </div>
                            <div class="new-invite-name">
                                {{ item.fromName }}
                            </div>
                            <div>
                                <div class="deny-btn btn-wrapper">
                                    <div
                                        class="btn-primary btn round-btn"
                                        @click="() => closeVideoChatByID(item.videoChatID)"
                                    >
                                        <BaseIcon
                                            class="icon phone-icon-rotate"
                                            name="phone"
                                            size="xs"
                                        />
                                    </div>
                                    <div class="btn-label">Decline</div>
                                </div>
                            </div>
                            <div>
                                <div class="accept-btn btn-wrapper">
                                    <div
                                        class="btn-primary btn round-btn"
                                        @click="() => joinChatByID(item.videoChatID)"
                                    >
                                        <BaseIcon class="icon" name="video" size="xs" />
                                    </div>
                                    <div class="btn-label">Accept</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Paper>
    </div>
</template>

<script>
import DialogService from '~/services/DialogService';
import MessageState from '~/store/customModules/messageModule';
import stringToColor from '~/utils/stringToColor';

export default {
    name: 'VideoChatInvitationDialog',

    props: {
        videoChatAction: String,
        videoChatID: String,
        fromName: String,
        fromAvatar: String,
    },
    data() {
        return {
            newInvites: [],
            confirmDecline: false,
        };
    },
    methods: {
        closeDialog() {
            localStorage.removeItem('wb_current_video_chat');
            this.confirmDecline = false;
            this.$interfaces.dialogModal.getState().resolver.res();
        },
        closeDialogConfirm() {
            this.confirmDecline = true;
        },
        backFromConfirm() {
            this.confirmDecline = false;
        },
        joinChat() {
            localStorage.setItem('wb_current_video_chat', this.videoChatID);
            DialogService.openVideoChatDialog({
                videoChatAction: this.videoChatAction,
                videoChatID: this.videoChatID,
            });
        },
        closeVideoChatByID(id) {
            let index = this.newInvites.findIndex(item => item.videoChatID === id);
            if (index >= 0) {
                this.newInvites.splice(index, 1);
            }
        },
        joinChatByID(id) {
            localStorage.setItem('wb_current_video_chat', id);
            DialogService.openVideoChatDialog({
                videoChatAction: 'invited',
                videoChatID: id,
            });
        },
        stringToColor(str) {
            return stringToColor(str);
        },
    },
    mounted() {
        this.$interfaces.communication['video-chat'].room.byid
            .video_chat_id(this.videoChatID)
            .get({ forceUpdate: true })
            .catch(err => {
                if (err.response.status === 400) {
                    this.$interfaces.messageModule.addNewMessage({
                        title: 'Video Chat Ended',
                        message: 'A video chat you participated in has ended.',
                        state: MessageState.NOTIFICATION,
                        duration: 4000,
                    });
                    this.closeDialog();
                }
            });
        this.$root.$on('video-chat-new-invite-invitation', data => {
            this.newInvites.push(data);
        });
    },
};
</script>

<style lang="css" scoped>

.wrapper {
    margin: 0 auto;
    max-width: var(--grid-width);
    width: var(--grid-width);
}

.avatar-wrapper {
    padding:20px;
    text-align:center;
}

.avatar-inner {
    font-size: 100%;
    border-radius: 50%;
    box-shadow: var(--shadow);
    overflow: hidden;
    display: flex;
    justify-content: center;
    height: 60px;
    width: 60px;
    margin-left:auto;
    margin-right:auto;
    margin-bottom:10px;

}

.avatar {
    width: 100%;
    height: 100%;
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
}

.outer-paper {
    /*min-width:500px;*/
    padding:10px;
    max-width: 350px;
    min-width: 300px;
}

.video-icon {
    display: inline !important;
    font-size: 20px;
}

.incoming-head {
    text-align:center;
    font-weight: bold;
}

.wrapper-div-vci {
    width: 100%;
    height: 100%;
    padding:40px;
}

.button-wrapper {
    position: relative;
    width:100%;
    height:80px;
}

.round-btn {
    font-size: 100%;
    display: flex;
    justify-content: center;
    height: 60px;
    width: 60px;
    border-radius: 50%;
    border: 0;
    cursor: pointer;
}

.confirm-button {
    width: 100%;
    border-radius: 50px;
    display: flex;
    align-items: center;
}

.confirm-text {
    margin-left:10px;
}

.btn-inner {
    position: absolute;
    text-align: center;
}

.btn-inner-confirm {
    width: 100%;
}

.accept-btn {
    right:0;
}

.accept-btn .round-btn {
    background-color: #4EC430 !important;
}

.deny-btn {
    left: 0;
}

.deny-btn .round-btn {
    background-color: #E83C24 !important;
}

.icon {
    font-size: 30px;
    color: white;
}

.phone-icon-rotate {
    transform: rotate(calc(180deg + 45deg)); /* Hack rotating the phone icon to lay down */
}

@media only screen and (max-width: 600px) {
    .video-root {
        padding: 0px !important;
    }
}

.new-invite-wrapper {
    border: 1px solid var(--gray);
    border-radius: 10px;
    padding: 10px;
    display:grid;
    grid-template-columns: 1fr 2fr 1fr 1fr;
    grid-gap:5px;
    align-items:center;
    justify-items:center;
    margin-bottom:5px;
}

.new-invite-wrapper .avatar-wrapper {
    padding:0;
}

.new-invite-wrapper .avatar-inner {
    margin: 0;
    width:40px;
    height:40px;
}

.new-invite-wrapper .round-btn {
    height: 40px;
    width: 40px;
}

.new-invite-wrapper .btn-label {
    font-size: 10px;
}

.new-invite-wrapper .btn-wrapper {
    text-align: center;
}

.new-invite-name {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    width: 100%;
}
</style>
